var map = {
	"./de.mjs": [
		9714,
		"node_modules_angular_common_locales_de_mjs"
	],
	"./en.mjs": [
		5180,
		"node_modules_angular_common_locales_en_mjs"
	],
	"./es.mjs": [
		2716,
		"node_modules_angular_common_locales_es_mjs"
	],
	"./extra/de.mjs": [
		4622,
		"node_modules_angular_common_locales_extra_de_mjs"
	],
	"./extra/en.mjs": [
		6219,
		"node_modules_angular_common_locales_extra_en_mjs"
	],
	"./extra/es.mjs": [
		79,
		"node_modules_angular_common_locales_extra_es_mjs"
	],
	"./extra/fr.mjs": [
		8922,
		"node_modules_angular_common_locales_extra_fr_mjs"
	],
	"./extra/it.mjs": [
		5828,
		"node_modules_angular_common_locales_extra_it_mjs"
	],
	"./extra/kde.mjs": [
		7636,
		"node_modules_angular_common_locales_extra_kde_mjs"
	],
	"./extra/pl.mjs": [
		2105,
		"node_modules_angular_common_locales_extra_pl_mjs"
	],
	"./extra/ses.mjs": [
		5120,
		"node_modules_angular_common_locales_extra_ses_mjs"
	],
	"./fr.mjs": [
		6182,
		"node_modules_angular_common_locales_fr_mjs"
	],
	"./it.mjs": [
		8113,
		"node_modules_angular_common_locales_it_mjs"
	],
	"./kde.mjs": [
		6873,
		"node_modules_angular_common_locales_kde_mjs"
	],
	"./pl.mjs": [
		1357,
		"node_modules_angular_common_locales_pl_mjs"
	],
	"./ses.mjs": [
		7705,
		"node_modules_angular_common_locales_ses_mjs"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9834;
module.exports = webpackAsyncContext;